export default __webpack_public_path__ + "static/media/d23.94201717.jpeg";